export { default } from './LightBoxImage';
